import React from "react";
import { Handle, Position } from "reactflow";
import { useResources } from "../../context/diagnosticFlowResources";

export default function TerminalNode({ data, selected }) {
  const resources = useResources();
  const hasError = data._invalid;

  const containerStyle = {
    padding: "14px 28px",
    borderRadius: "28px",
    background: hasError
      ? "linear-gradient(135deg, #ef5350, #e53935)"
      : "linear-gradient(135deg, #ef5350, #d32f2f)",
    color: "#fff",
    fontSize: "14px",
    fontWeight: 600,
    textAlign: "center",
    minWidth: "130px",
    boxShadow: selected
      ? "0 0 0 3px #1a73e8, 0 4px 14px rgba(0,0,0,0.2)"
      : hasError
      ? "0 0 0 2px #e53935, 0 2px 8px rgba(229,57,53,0.3), 0 0 12px rgba(229,57,53,0.2)"
      : "0 2px 8px rgba(211,47,47,0.3)",
    transition: "all 0.2s ease",
    cursor: "pointer",
    letterSpacing: "0.5px",
  };

  return (
    <div style={containerStyle}>
      <Handle
        type="target"
        position={Position.Top}
        style={{
          width: "10px",
          height: "10px",
          background: "#fff",
          border: "2px solid #d32f2f",
          top: "-5px",
        }}
      />
      {data.label ? (
        data.label
      ) : (
        <span style={{ opacity: 0.7, fontStyle: "italic" }}>{resources["End"]}</span>
      )}
    </div>
  );
}
